import { Suspense, useState } from 'react';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { lazy } from 'utils/generic/lazy';
import { Portal } from 'components/Shared/Portal';

const { CommunityChatContent } = lazy(
  () => import(/* webpackChunkName: "CommunityChat" */ './Content')
);

export const CommunityChat = () => {
  const [communityChatAvailable] = useState(
    () => !document.querySelector('.popup-body') // Check if project is mounted through iframe
  );

  if (!SpringConfigs.COMMUNITY_CHAT_ENABLED || !communityChatAvailable) {
    return null;
  }

  return (
    <Suspense>
      <Portal>
        <CommunityChatContent />
      </Portal>
    </Suspense>
  );
};
